export const doctorWhoWordList = [
  'omega',
  'ashad',
  'leela',
  'monks',
  'trial',
  'axons',
  'oswin',
  'class',
  'tenza',
  'space',
  'myrka',
  'chase',
  'telos',
  'rusty',
  'morax',
  'akido',
  'earth',
  'giddy',
  'tegan',
  'lumic',
  'noble',
  'kaled',
  'ianto',
  'kolos',
  'izlyr',
  'blink',
  'auton',
  'mummy',
  'adric',
  'tyler',
  'marco',
  'tasha',
  'scarf',
  'vanir',
  'alpha',
  'tigus',
  'mauve',
  'varos',
  'river',
  'morok',
  'missy',
  'zodin',
  'sigma',
  'laser',
  'baker',
  'voord',
  'zanak',
  'sarah',
  'skaro',
  'drums',
  'susan',
  'exile',
  'sskel',
  'house',
  'raaga',
  'quark',
  'yetis',
  'sonic',
  'vicki',
  'nerys',
  'clara',
  'mouri',
  'chloe',
  'smith',
  'alfie',
  'rodan',
  'azael',
  'mutts',
  'theta',
  'elton',
  'staal',
  'jones',
  'malus',
  'janis',
  'woods',
  'craig',
  'borad',
  'raven',
  'harry',
  'clive',
  'yates',
  'rutan',
  'sarff',
  'styre',
  'zygon',
  'ssorg',
  'avery',
  'dandy',
  'flood',
  'wotan',
  'artie',
  'lords',
  'kinda',
  'lobos',
  'ponds',
  'alien',
  'hedin',
  'helen',
  'falls',
  'curse',
  'nimon',
  'probe',
  'kangs',
  'quill',
  'paper',
  'potts',
  'chang',
  'logar',
  'kemel',
  'thals',
  'rigsy',
  'xeron',
  'dalek',
  'flesh',
  'solon',
  'azure',
  'cybus',
  'ribos',
  'mavic',
  'vogan',
  'nyssa',
  'capel',
  'kalid',
  'benny',
  'timey',
  'wharf',
  'donna',
  'condo',
  'gelth',
  'macra',
  'clown',
  'ohica',
  'kroll',
  'trion',
  'zocci',
  'storm',
  'pluto',
  'greel',
  'janus',
  'maxil',
  'klieg',
  'ergon',
  'grace',
  'delta',
  'maria',
  'mccoy',
  'shoal',
  'sandy',
  'vardy',
  'dregs',
  'hetra',
  'cyber',
  'brown',
  'wimey',
  'rills',
  'stars',
  'child',
  'xeros',
  'poosh',
  'zombo',
  'wells',
  'taran',
  'nyder',
  'mogar',
  'nerva',
  'robot',
  'maaga',
  'wirrn',
  'disco',
  'kraal',
  'maebh',
  'beast',
  'ogron',
  'zarbi',
  'saxon',
  'glitz',
  'pears',
  'benni',
  'smile',
  'shada',
  'solos',
  'polly',
  'pting',
  'orion',
  'varga',
  'chula',
  'flint',
  'slabs',
  'human',
  'erato',
  'tesla',
  'kandy',
  'strax',
  'linda',
  'aneth',
  'danny',
  'cheem',
  'piper',
  'droid',
  'binro',
  'varsh',
  'clyde',
  'death',
  'ogros',
  'basil',
  'idris',
  'jelly',
  'sweet',
  'wiped',
  'sally',
  'jamie',
  'angie',
  'swarm',
  'razor',
  'jenny',
  'grant',
  'rotor',
  'shona',
]
